module.exports = "<dashboard-external *ngIf=\"isExternal\"></dashboard-external>\r\n<dashboard-internal *ngIf=\"isInternal\"></dashboard-internal>"